import { withTranslation } from 'react-i18next';

import ReactSelect from '../../../../components/ReactSelect';
import { GRID_SELECT } from '../../GscTools/selectStyles';
import { SOURCES, sourceLabel, sourceScope } from '../sources';

/**
 * This report's own scope control: which of the three news surfaces to read.
 *
 * It replaces the shared search-type select rather than sitting beside it. That select offers six
 * surfaces and three of them are not this report's; offering them and then refusing them would be
 * a control that lies about what it can do. Behind the same Apply as the dates, because changing
 * the source changes every request on the page — and the figures from the old source are cleared
 * with it rather than left under the new source's heading.
 */
function ExtraControls({ t, draft, onChange }) {
    const options = SOURCES.map((source) => ({ value: source, label: sourceLabel(t, source) }));

    return (
        <div className="gsc-tool-field">
            <label>{t('tools.discover_news.controls.source')}</label>
            <ReactSelect
                options={options}
                value={options.find((item) => item.value === draft.searchType)}
                blurInputOnSelect={true}
                classname="gsc-tool-select"
                controlStyles={GRID_SELECT}
                customeOnChange={(item) => onChange({ searchType: item.value })}
            />
            <span className="gsc-tool-field-note">{sourceScope(t, draft.searchType)}</span>
        </div>
    );
}

export default withTranslation()(ExtraControls);
